module.exports = __webpack_public_path__ + "static/img/404.13ef933.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/appIndex/404.png
// module id = kdFO
// module chunks = 32